<!--It is created by nikhil 10-09-2020-->
<!--Report Configuration Component-->
<button type="button" class="close" (click)="closePopup()">&times;</button>
<div style="margin-left: 15px;margin-top: 15px;">
  <label i18n="@@spmsUserReg" class="textColour">Add Filter</label>
  <span class="example-spacer"></span>
</div>
<div class="topDiv">
  <div class="agGridOuterDiv"  style="margin-top: 3%;padding-left: 10px;padding-right:10px">

      <div class="row" style="margin-bottom:2rem">
        <div class="col-lg-1" style="margin-bottom:1rem"></div>
        <div class="col-lg-5" style="margin-bottom:1rem">

          <ag-grid-angular
            class="ag-theme-balham table-width-fields tablestyles square scrollbar-dusty-grass square thin" style="width: auto; height: 50vh;overflow: hidden;"
            [columnDefs]="columnDefsForObjects"  [animateRows]="true"
            [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowSelection]="rowSelection"
            [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"
            [enableRangeSelection]="true" [debug]="true" (gridReady)="onGridReadyForObjects($event)"
            (cellClicked)="cellClickedObjects($event,0)" [hidden]="!true">
          </ag-grid-angular>

        </div>

       

        <div class="col-lg-5">

          <div style="margin-bottom:1rem">

            <ag-grid-angular class="ag-theme-balham square scrollbar-dusty-grass square thin"
              style="width: auto; height: 50vh;overflow: hidden;" [columnDefs]="columnDefsForTablesFields"
               [animateRows]="true"  [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true" [rowSelection]="rowSelectionForTablesFields"
              [groupSelectsChildren]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true"
              [components]="components"  (rowSelected)="onRowSelected($event)"
              (gridReady)="onGridReadyForTablesFields($event,ngModelObjectTemporary)" [hidden]="!true"
              >
            </ag-grid-angular>

          </div>

        </div>
        <div class="col-lg-1"></div>
      </div>
    </div>
   
        <div class="container" style="border-bottom: 0.01px ridge coral;margin-bottom: 3em;">
      <div class="row" style="margin-bottom:1rem">
        <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                  <div class="row topRowMargins">
                  
      <label style="font-weight: 500;
      font-size: larger;
      color: black;">Filters <em class="fas fa-filter" style="font-size:20px"></em></label>
      </div>
          </div>
          </div>
       
        <div class="container">
        <div  class="row" *ngIf="showFilter" style="margin-top: -30px;margin-bottom: 30px;">
        <div class="table-responsive">
          <table class="table" style="margin-top: -57px;">
            <caption></caption>
           
            <thead>
              <tr>
                <th class="th-lg">Key</th>
                <th class="th-lg">Condition</th>
                <th class="th-lg">Value</th>
                <th class="th-lg">Remove</th>
              </tr>
            </thead>
            <tbody style="border:none;">
              <tr *ngFor="let whereData of where; let k= index;">
                <td class="conditionsalign">{{whereData.whereKey}}</td>
                <td class="conditionsalign" style="padding-left: 115px;">{{whereData.whereCondition}}</td>
                <td class="conditionsalign" style="padding-left: 120px;">{{whereData.whereValue}}</td>
                <td class="conditionsalign" style="text-align: end;
                padding-right: 33px;"><button  class ="CloseButtonStyle"><span> <em (click)="deleteWhere(k)" class="fas fa-minus" style="color: white;"></em></span></button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
     
            <form novalidate [formGroup]="formValidWhere">
              <div>
                <div class="row topRowMargins" style="margin-top: -25px;">
                  <div class="col-lg-4">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFields">Fields</mat-label>
                      <mat-select [(ngModel)]="whereData.fieldsWhere" (selectionChange)="whereKey($event.value)" formControlName="fieldsWhere">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let field of fieldsData" [(value)]="field.townshipNameAndFields">
                          {{field.townshipFieldsDescription}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-3">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCConditionalOperators">Condition</mat-label>
                      <mat-select [(ngModel)]="whereData.conditionalOperatorWhere"
                        formControlName="conditionalOperatorWhere">
                        <mat-option>None</mat-option>
                        <mat-option *ngFor="let conditionalOperator of conditionalOperatorDataWhere"
                          [(value)]="conditionalOperator.value">
                          {{conditionalOperator.name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                  <div *ngIf="fieldChange">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCEnterValue">Enter Value</mat-label>
                      <input matInput type="text" maxlength="50" formControlName="enterValueWhere"
                        [(ngModel)]="whereData.enterValueWhere">
                    </mat-form-field>
                  </div>
                  <div *ngIf="dateChange">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERLastname">Select Date</mat-label>
                      <input matInput [(ngModel)]="whereData.enterValueWhereDate" [matDatepicker]="whereDate"
                          readonly formControlName="enterValueWhere">
                      <mat-datepicker-toggle matSuffix [for]="whereDate">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #whereDate></mat-datepicker>
                  </mat-form-field>
                  </div>
                </div>
               
                  <div class="col-lg-1">
                  <label (click)="addWhere()" style="    margin-top: 9px;
                  background: green;
                  margin-bottom: auto;
                  padding: 1px 10px;
                  border-radius: 15px;"><em class="fas fa-plus" style="color: antiquewhite;"></em></label>
                </div>
                </div>
              </div>
            </form>
        </div>

        <div class="container" style="border-bottom: 0.01px ridge coral;margin-bottom: 3em;">
          <div class="row" style="margin-bottom:1rem">
            <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                      <div class="row topRowMargins">
                     
          <label style="font-weight: 500;
          font-size: larger;
          color: black;">Sorting<em class="fas fa-sort" style="    font-size: 23px;
    padding: 0px 0px 0px 6px;"></em></label>
          </div>
              </div>
              </div>
              
            <div class="container">
              <div class="row" *ngIf="showOrderBy" style="margin-top: -30px;
              margin-bottom: 30px;">
              <div class="table-responsive">
                <table class="table" style="margin-top: -57px;"><caption></caption>
                  <thead>
                    <tr>
                      <th class="th-lg">Key</th>
                      <th class="th-lg">Allign</th>
                      <th class="th-lg">Remove</th>
                      <th class="th-lg">Remove</th>
                    </tr>
                  </thead>
                  <tbody style="border:none;">
                    <tr *ngFor="let orderData of orderBy;let o= index;">
                      <td class="conditionsalign">{{orderData.orderKey}}</td>
                      <td class="conditionsalign" style="padding-left: 115px;">{{orderData.orderAllign}}</td>
                      <td class="conditionsalign" style="text-align: end;
                      padding-right: 36px;"><button  class ="CloseButtonStyle"><span> <em (click)="deleteOrder(o)" class="fas fa-minus" style="color: white;"></em></span></button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        
                <form novalidate [formGroup]="formValidWhere">
                  <div>
                    <div class="row topRowMargins" style="margin-top: -25px;">
                      <div class="col-lg-4">
                        <mat-form-field appearance="outline">
                          <mat-label i18n="@@RCFields">Fields</mat-label>
                          <mat-select [(ngModel)]="orderByData.fieldsOrderBy" formControlName="fieldsOrderBy">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let field of fieldsData" [(value)]="field.townshipNameAndFields">
                              {{field.townshipFieldsDescription}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-4">
                        <mat-form-field appearance="outline">
                          <mat-label i18n="@@RCConditionalOperators">Sorting</mat-label>
                          <mat-select [(ngModel)]="orderByData.arrangeOrderBy" formControlName="arrangeOrderBy">
                            <mat-option>None</mat-option>
                            <mat-option *ngFor="let arrange of arrangeDataOrderBy" [(value)]="arrange.value">
                              {{arrange.name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    
                      <div class="col-lg-1">
                    <label (click)="addOrderBy()" style="    margin-top: 9px;
                  background: green;
                  margin-bottom: auto;
                  padding: 1px 10px;
                  border-radius: 15px;"><em class="fas fa-plus" style="    color: antiquewhite;"></em></label>
                  </div>
                  </div>
                </div>
                </form>
            </div>

            <div class="container">
              <div class="row" style="margin-bottom:1rem">
                <div class="col-lg" style="margin-bottom:1rem;margin-top: -30px;">
                          <div class="row topRowMargins">
                           
              <label style="font-weight: 500;
              font-size: larger;
              color: black;">Aggregate<em class="fas fa-calculator" style="    font-size: 23px;
    padding: 0px 0px 0px 6px;"></em></label>
              </div>
                  </div>
                  </div>
               
                <div class="container">
                  <div class="row" *ngIf="showAggregate" style="margin-top: -30px;
                  margin-bottom: 30px;">
                  <div class="table-responsive">
                    <table class="table" style="margin-top: -57px;">
                      <caption></caption>
                      <thead>
                        <tr>
                          <th class="th-lg">Key</th>
                          <th class="th-lg">Allign</th>
                          <th class="th-lg">Remove</th>
                          <th class="th-lg">Remove</th>
                        </tr>
                      </thead>
                      <tbody style="border:none;">
                        <tr *ngFor="let aggregateData of aggregateBy;let a= index;">
                          <td class="conditionsalign">{{aggregateData.aggregateKey}}</td>
                          <td class="conditionsalign" style="padding-left: 115px;">{{aggregateData.aggregate}}</td>
                          <td class="conditionsalign" style="text-align: end;
                          padding-right: 36px;"><button  class ="CloseButtonStyle"><span> <em (click)="deleteAggregate(a)" class="fas fa-minus" style="color: white;"></em></span></button></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
               
                    <form novalidate [formGroup]="formValidWhere">
                      <div>
                        <div class="row topRowMargins" style="margin-top: -25px;">
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline">
                              <mat-label i18n="@@RCFields">Fields</mat-label>
                              <mat-select [(ngModel)]="aggregateByData.fieldsAggregateBy" formControlName="fieldsAggredateBy">
                                <mat-option>None</mat-option>
                                <mat-option *ngFor="let field of aggregateArray" [(value)]="field.townshipNameAndFields">
                                  {{field.townshipFieldsDescription}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div class="col-lg-4">
                            <mat-form-field appearance="outline">
                              <mat-label i18n="@@RCFields">Aggregate</mat-label>
                              <mat-select [(ngModel)]="aggregateByData.arrangeaggregateBy" formControlName="arrangeaggregateBy">
                                <mat-option>None</mat-option>
                                <mat-option *ngFor="let aggregate of arrangeDataBy" [(value)]="aggregate.value">
                                  {{aggregate.name}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                     
                          <div class="col-lg-1">
                          <label (click)="addAggregate()" style="    margin-top: 9px;
                  background: green;
                  margin-bottom: auto;
                  padding: 1px 10px;
                  border-radius: 15px;"><em class="fas fa-plus" style="    color: antiquewhite;"></em></label>
                      </div>
                      </div>
                    </div>
                    </form>
                </div>

      <div class="col-lg">
        <div class="container" style="text-align: center;">
          <div class="row topRowMargins">
            <div class="col-lg-4"></div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="run(0)"
              class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;"
             [style.background-color]="backgroundColorButton">Run</button>
            </div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="cancel()"
              class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;" [style.border-color]="backgroundColorButton">Cancel</button>
            </div>
            <div class="col-lg-4">
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-bottom:2rem">

        <div class="col-lg-12">
          <mat-toolbar class="agGridtoperDiv card" style="background: rgb(228 227 230 / 41%);margin-top: 0;border-top: 1px solid #a9a9a9a8;
          border-right: 1px solid #a9a9a9a8;border-left: 1px solid #a9a9a9a8;">
              <label i18n="@@spmsUserReg" class="textColours">Report Configuration Data</label>
              <span class="example-spacer"></span>
            <em class="fas fa-download example-icon" title="Download" (click)="onExport()" style="color: red;"></em>
            <em class="fas fa-poll example-icon" title="Bar" (click)="barChart()" style="color: slategrey;font-size: larger;"></em>
            <em class="fas fa-pie-chart example-icon" title="Pie" (click)="pieChart()" style="color: forestgreen;font-size: larger;"></em>
            <div class="insertPageNoDiv">
              <mat-form-field appearance="outline">
                  <mat-label i18n="@@Targetpageno">Page No</mat-label>
                  <input matInput type="text" (input)="onSearchChange($event.target.value)">
              </mat-form-field>
          </div>
          <div class="selectRecordsDiv" style="width:9.5%">
              <mat-form-field appearance="outline" style="width:100%">
                  <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                  <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
                      <mat-option value="10" selected>10</mat-option>
                      <mat-option value="200">200</mat-option>
                      <mat-option value="300">300</mat-option>
                      <mat-option value="400">400</mat-option>
                  </mat-select>

              </mat-form-field>
          </div>
          <div class="card pagination paginationFirstButton paginationFirstlastButton">
              <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
          </div>
          <div class="card pagination paginationButtons btn-rounded">
              <ul>
                  <li class="paginationliicon"><em class="fas fa-angle-left waves-effect waves-light"
                          (click)="onBtPrevious()"></em></li>
                  <li>{{currentPage}}/{{totalPages}}</li>
                  <li class="paginationliicon" style="padding:0;"><em
                          class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em></li>
              </ul>
          </div>
          <div class="card pagination paginationLastButton paginationFirstlastButton">
              <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
          </div>
          </mat-toolbar>
          <ag-grid-angular *ngIf="showgridData" class="ag-theme-balham table-width-schedule-report tablestyles square scrollbar-dusty-grass square thin"
            [columnDefs]="columnDefsForReportingConfiguration"  [animateRows]="true"
             [pagination]="true" [defaultColDef]="defaultColDefs"
            [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true"
            [floatingFiltersHeight]="45" [paginationPageSize]="paginationPageSize"
            [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"
            [rowClassRules]="rowClassRules" (paginationChanged)="onPaginationChanged()"
            (gridReady)="onGridReadyForReportingConfiguration($event)" [hidden]="!true">
          </ag-grid-angular>
            <div class="row topRowMargins">
              <!-- <ag-charts-angular *ngIf="barChartData" style="position: absolute; top: 100px; right: 0; bottom: -400px; left: 0;"
              [options]="options">
        </ag-charts-angular>
        <ag-charts-angular *ngIf="pieChartData" style="position: absolute; top: 100px; right: 0; bottom: -400px; left: 0;"
        [options]="options">
        </ag-charts-angular> -->
         
          </div>
     

        </div>

      </div>
      <div class="col-lg" *ngIf="showgridData">
        <div class="container" style="text-align: center;">
          <div class="row topRowMargins">
            <div class="col-lg-5"></div>
            <div class="col-lg-2" *ngIf="saveButton">
              <button i18n="@@TMRunButton" type="button" (click)="save()"
              class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;"
             [style.background-color]="backgroundColorButton">Save</button>
            </div>
            <div class="col-lg-2" *ngIf="updateButton">
              <button i18n="@@TMRunButton" type="button" (click)="update()"
              class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;"
             [style.background-color]="backgroundColorButton">Update</button>
            </div>
            <div class="col-lg-5">
            </div>
          </div>
        </div>
      </div>

    </div>
